// extracted by mini-css-extract-plugin
module.exports = {"error":"WnkvXZgQ","label":"DsA09M+Q","invalid":"o1RZckGj","description":"aUIoA2D4"};